'use client';

import { BookDemoButton } from '@/components/ui';
import IndustryHero from '@/components/industry/IndustryHero';
import IndustryCommandCentre from '@/components/industry/IndustryCommandCentre';
import { useTranslation } from '@/hooks/useTranslation';

const BLUE = { color: 'var(--brand)' };
const DEEP = { color: 'var(--brand-deep)' };

/* Sector command-centre data — Retail shopper & order operations.
   Sample/mock dashboard content (not marketing copy). */
const CC = {
  pulseTitle: 'Shopper & order pulse',
  kpis: [
    { val: '2,640', lbl: 'Live mentions', live: true },
    { val: '110', lbl: 'Open escalations' },
    { val: '2.7m', lbl: 'Avg. first response' },
  ],
  sentiment: [
    { lbl: 'Positive', pct: 40, tone: 'positive' },
    { lbl: 'Neutral', pct: 33, tone: 'neutral' },
    { lbl: 'Negative', pct: 27, tone: 'negative' },
  ],
  sla: { pct: 81, lbl: 'SLA met' },
  tickerLabel: 'Incoming complaints',
  tickerItems: [
    { letter: 'P', text: 'Order delayed past delivery date', handle: '@priya_s', tag: 'Delivery', tagLevel: 'med' },
    { letter: 'A', text: 'Received wrong item, no help', handle: '@arjun_d', tag: 'Order', tagLevel: 'high' },
    { letter: 'S', text: 'Return pickup not scheduled', handle: '@sneha_k', tag: 'Returns', tagLevel: 'med' },
    { letter: 'R', text: 'Refund pending for 10 days', handle: '@rohan_m', tag: 'Refund', tagLevel: 'high' },
  ],
  chips: [
    { variant: 'light', title: 'Churn signal', sub: 'Repeat buyers turning negative' },
    { variant: 'dark', title: 'AgentIQ routed', sub: 'Refund case → ops in 2s' },
  ],
};

export default function RetailHero() {
  const { t } = useTranslation();

  return (
    <IndustryHero
      layout="visual"
      breadcrumb={{
        ariaLabel: t('industries_retail_ecommerce.breadcrumb'),
        label: t('footer.col.industries'),
        href: '/industries',
        current: t('industries_retail_ecommerce.retail_ecommerce'),
      }}
      title={
        <>
          {t('industries_retail_ecommerce.from')}{' '}
          <span className="serif-accent italic">{t('industries_retail_ecommerce.delivery_complaint_to_loyal_shopper')}</span>
          {' '}{t('industries_retail_ecommerce.the_ecommerce_customer_experience_p')}{' '}
          <span className="serif-accent italic">{t('industries_retail_ecommerce.peak_season_quick_commerce_and_d2c')}</span>
        </>
      }
      lead={
        <>
          {t('industries_retail_ecommerce.indias_ecommerce_market_hit_400_bil')} <span style={BLUE}>{t('industries_retail_ecommerce.delivery_complaint')}</span> {t('industries_retail_ecommerce.posted_publicly_during_big_billion')} <span style={DEEP}>{t('industries_retail_ecommerce.locobuzz_intercepts_all_three')}</span>
        </>
      }
      actions={<BookDemoButton label={t('industries_retail_ecommerce.hero_cta_primary')} />}
      visual={<IndustryCommandCentre ariaLabel="Retail shopper experience command centre" {...CC} />}
    />
  );
}
